import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';

interface LayoutProps {
  children: React.ReactNode;
  hideNav?: boolean;
}

export function Layout({ children, hideNav = false }: LayoutProps) {
  const { user, isAuthenticated, signIn, signOut } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col">
      {!hideNav && (
        <header className="bg-white/80 backdrop-blur-md border-b border-gray-100 sticky top-0 z-50">
          <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
            <Link
              to="/"
              className="text-xl font-bold bg-gradient-to-r from-violet-600 to-pink-500 bg-clip-text text-transparent hover:opacity-80 transition-opacity"
            >
              About Bloody Time!
            </Link>

            <div className="flex items-center gap-4">
              {isAuthenticated ? (
                <>
                  <Link
                    to="/dashboard"
                    className="text-sm font-medium text-gray-700 hover:text-violet-600 transition-colors"
                  >
                    My Events
                  </Link>
                  <Link
                    to="/events/new"
                    className="text-sm font-medium text-gray-700 hover:text-violet-600 transition-colors"
                  >
                    Create Event
                  </Link>
                  <div className="flex items-center gap-3 pl-4 border-l border-gray-200">
                    <span className="text-sm text-gray-500">{user?.name || user?.email}</span>
                    <button
                      onClick={signOut}
                      className="text-sm font-medium text-gray-500 hover:text-red-500 transition-colors"
                    >
                      Sign out
                    </button>
                  </div>
                </>
              ) : (
                <button
                  onClick={signIn}
                  className="btn-primary text-sm"
                >
                  Sign in with Google
                </button>
              )}
            </div>
          </nav>
        </header>
      )}

      <main className="flex-1">{children}</main>

      <footer className="bg-gray-50 border-t border-gray-100 py-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-sm text-gray-500">
          <p>&copy; {new Date().getFullYear()} About Bloody Time! &mdash; Events made easy. Beautifully.</p>
        </div>
      </footer>
    </div>
  );
}
